/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { ConfigService } from './config.service';
import { EventService } from './event.service';

@Injectable()
export class VersionService {

  private version: string = null;

  constructor(private configService: ConfigService,
              private eventService: EventService) { }

  /**
   * Boot up the version checker, continuously poll for updates
   */
  boot() {
    setInterval(() => {
      this.configService.appVersion().subscribe(
        (result: any) => {
          let minor = result.version.split('.')[1];
          // if version = null it's the first load
          if (this.version) {
            if (minor != this.version) {
              this.eventService.versionChange$.emit(result.version);
            }
          }
          this.version = minor;
        },
        error => {/*no-op*/}
      );
    }, 30000);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/version.service.ts